export default __webpack_public_path__ + "static/media/videoLogo721tres.7b4c8b8e.mp4";